<template>
  <div>
    <div class="table-1">
      <table width="100%">
        <thead>
          <tr v-if="getLanguagePL">
            <th align="left">Lokalizacja</th>
            <th style="text-align:center;">Dostępność</th>
            <th style="text-align:center;">Piętro</th>
            <th style="text-align:center;">Powierzchnia</th>
            <th align="left"></th>
          </tr>
          <tr v-if="getLanguageEN">
            <th align="left">Location</th>
            <th style="text-align:center;">Availability</th>
            <th style="text-align:center;">Floor</th>
            <th style="text-align:center;">Area</th>
            <th align="left"></th>
          </tr>
          <tr v-if="getLanguageES">
            <th align="left">Ubicaciones</th>
            <th style="text-align:center;">Disponibilidad</th>
            <th style="text-align:center;">Piso</th>
            <th style="text-align:center;">Tamaño</th>
            <th align="left"></th>
          </tr>
          <tr v-if="getLanguageUA">
            <th align="left">Місцезнаходження</th>
            <th style="text-align:center;">Наявність</th>
            <th style="text-align:center;">Поверх</th>
            <th style="text-align:center;">Поверхня</th>
            <th align="left"></th>
          </tr>
        </thead>
        <tbody>
          <v-fs-tr-table
            v-for="(portfolio, index) in dostepnoscItems"
            :key="index"
            :portfolio="portfolio"
          ></v-fs-tr-table>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Table from "./dostepnoscComponents/Table.vue";
export default {
  components: {
    "v-fs-tr-table": Table
  },
  computed: {
    dostepnoscItems() {
      return this.$store.getters["wordpressRest/getDostepnoscData"];
    },
    getLanguagePL() {
      return document.documentElement.lang === "pl-PL";
    },
    getLanguageEN() {
      return document.documentElement.lang === "en-US";
    },
    getLanguageUA() {
      return document.documentElement.lang === "uk-UA";
    },
    getLanguageES() {
      return document.documentElement.lang === "es-ES";
    }
  },
  created() {
    this.$store.dispatch("wordpressRest/getDostepnosc");
  }
};
</script>

<style lang="scss" scoped>
.table-1 table th {
  background: #005500;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/Dostepnosc.vue